import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";

import t from "./common/localization";
import EditItemView from "./EditItemView";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Typography,
  FormControlLabel,
  Checkbox,
  Paper,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: "flex",
  },
  textField: {
    margin: "4px",
    width: "85%",
  },
  root: {
    padding: "10px",
    margin: "10px",
    marginLeft: "60px",
  },
}));

const ComputedAttributesAddPage = () => {
  const classes = useStyles();

  const [item, setItem] = useState();
  console.log(item, " ComputedAttributesAddPage item");
  return (
    <EditItemView endpoint="attributes/computed" item={item} setItem={setItem}>
      {item && (
        <>
          <div className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper elevation={3}>
                  <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1">
                        {t("sharedRequired")}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container spacing={3}>
                        <Grid item xs={6}>
                          <TextField
                            className={classes.textField}
                            margin="normal"
                            InputProps={{ disableUnderline: true }}
                            value={item.description || ""}
                            onChange={(event) =>
                              setItem({
                                ...item,
                                description: event.target.value,
                              })
                            }
                            label={"Description"}
                            variant="standard"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            className={classes.textField}
                            margin="normal"
                            InputProps={{ disableUnderline: true }}
                            value={item.attribute || ""}
                            onChange={(event) =>
                              setItem({
                                ...item,
                                attribute: event.target.value,
                              })
                            }
                            label={"Attribute"}
                            variant="standard"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            className={classes.textField}
                            margin="normal"
                            InputProps={{ disableUnderline: true }}
                            value={item.expression || ""}
                            onChange={(event) =>
                              setItem({
                                ...item,
                                expression: event.target.value,
                              })
                            }
                            label={"Expression"}
                            variant="standard"
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl
                            variant="standard"
                            margin="normal"
                            fullWidth
                          >
                            <InputLabel>{t("sharedType")}</InputLabel>
                            <Select
                              disableUnderline={true}
                              value={item.type || ""}
                              onChange={(event) =>
                                setItem({ ...item, type: event.target.value })
                              }
                            >
                              <MenuItem value={"string"}>
                                {t("sharedTypeString")}
                              </MenuItem>
                              <MenuItem value={"number"}>
                                {t("sharedTypeNumber")}
                              </MenuItem>
                              <MenuItem value={"boolean"}>
                                {t("sharedTypeBoolean")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                checked={item.vendor}
                                onChange={(event) =>
                                  setItem({
                                    ...item,
                                    vendor: event.target.checked,
                                  })
                                }
                              />
                            }
                            label={"Vendor"}
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Paper>
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </EditItemView>
  );
};

export default ComputedAttributesAddPage;
